import { Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { FindUserByNicknevResponseDto } from '../../../modules/personal-site/personal-site.interfaces';
import { UrlShortenerService } from '../../services/url-shortener/url-shortener.service';
import { Router } from '@angular/router';
import { LandingPageService } from '../../../modules/landing-pages/landing-page.service';
import { SocialShareService } from '../../services/social-share/social-share.service';
import { isPlatformBrowser } from '@angular/common';
import { GetShortUrlResponseDto } from '../../interfaces/url-shortener.interfaces';
import { ShareDialogComponent } from '../../dialogs/share-dialog/share-dialog.component';

@Component({
  selector: 'ose-global-share-ribbon',
  templateUrl: './global-share-ribbon.component.html',
  styleUrls: ['./global-share-ribbon.component.scss'],
})
export class GlobalShareRibbonComponent implements OnInit, OnDestroy {
  @Input() standalone: boolean;
  @ViewChild(ShareDialogComponent) shareDialogComponent: ShareDialogComponent;

  currentShareUrl: string;
  recommender: FindUserByNicknevResponseDto;

  constructor(
    private urlShortenerService: UrlShortenerService,
    private router: Router,
    private landingPageService: LandingPageService,
    private socialShareService: SocialShareService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.socialShareService.innerWidth = window.innerWidth;
    }
    this.recommender = this.landingPageService.getRecommender();
    this.setCurrentShareUrl();
  }

  private setCurrentShareUrl(): void {
    this.urlShortenerService
      .shortenUrl({
        longUrl: this.router.url,
        recommender: this.recommender?.nicknev,
      })
      .subscribe((response: GetShortUrlResponseDto) => {
        this.currentShareUrl = this.socialShareService.generateCurrentUrl(response.shortUrl);
      });
  }

  shareToMessenger(): void {
    this.socialShareService.shareToMessenger(this.currentShareUrl);
  }

  shareToViber(): void {
    this.socialShareService.shareToViber(this.currentShareUrl);
  }

  shareToFacebook(): void {
    this.socialShareService.shareToFacebook(this.currentShareUrl);
  }

  shareToWhatsapp(): void {
    this.socialShareService.shareToWhatsapp(this.currentShareUrl);
  }

  shareToTelegram(): void {
    this.socialShareService.shareToTelegram(this.currentShareUrl);
  }

  copyShortUlr(): void {
    this.socialShareService.copyShortUlr(this.currentShareUrl);
  }

  openShareDialog(): void {
    this.shareDialogComponent.open();
  }

  ngOnDestroy(): void {}
}
